module.exports = __webpack_public_path__ + "static/img/icon_exp@2x.ab38ebbd.png";